const CONFERENCIAS = [
  {
    nome: 'AFC', cor: '#C8102E',
    divisoes: [
      { nome: 'Leste', times: ['BUF', 'MIA', 'NE', 'NYJ'] },
      { nome: 'Norte', times: ['BAL', 'CIN', 'CLE', 'PIT'] },
      { nome: 'Sul',   times: ['HOU', 'IND', 'JAX', 'TEN'] },
      { nome: 'Oeste', times: ['DEN', 'KC',  'LAC', 'LV']  },
    ]
  },
  {
    nome: 'NFC', cor: '#013369',
    divisoes: [
      { nome: 'Leste', times: ['DAL', 'NYG', 'PHI', 'WSH'] },
      { nome: 'Norte', times: ['CHI', 'DET', 'GB',  'MIN'] },
      { nome: 'Sul',   times: ['ATL', 'CAR', 'NO',  'TB']  },
      { nome: 'Oeste', times: ['ARI', 'LAR', 'SEA', 'SF']  },
    ]
  }
]

export default function TimeFavoritoSelector({ valor, onChange }) {
  return (
    <div>
      {CONFERENCIAS.map(conf => (
        <div key={conf.nome} style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: conf.cor, letterSpacing: 1, marginBottom: 8, textTransform: 'uppercase' }}>
            {conf.nome}
          </div>
          {conf.divisoes.map(div => (
            <div key={div.nome} style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 10, color: '#aaa', marginBottom: 5 }}>Divisão {div.nome}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                {div.times.map(abbr => {
                  const sel = valor === abbr
                  return (
                    <button
                      key={abbr}
                      type="button"
                      onClick={() => onChange(sel ? null : abbr)}
                      style={{
                        flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
                        gap: 4, padding: '8px 4px', borderRadius: 8, cursor: 'pointer',
                        border: sel ? '2px solid #D85A30' : '0.5px solid #ddd',
                        background: sel ? '#FAECE7' : 'white', transition: 'all .12s',
                      }}
                    >
                      <img
                        src={`/logos/${abbr.toLowerCase()}.png`}
                        alt={abbr}
                        style={{ width: 32, height: 32, objectFit: 'contain' }}
                        onError={e => { e.target.style.display = 'none' }}
                      />
                      <span style={{ fontSize: 9, fontWeight: 600, color: sel ? '#D85A30' : '#666' }}>
                        {abbr}
                      </span>
                    </button>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      ))}
      {valor && (
        <button
          type="button"
          onClick={() => onChange(null)}
          style={{ fontSize: 11, color: '#aaa', background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginTop: 2 }}
        >
          ✕ Remover preferência
        </button>
      )}
    </div>
  )
}
